<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box">
                        <span class="info-box-icon bg-info elevation-1"><i class="fas fa-pen-fancy"></i></span>

                        <div class="info-box-content">
                            <a :href=this.testimonial_route><span class="info-box-text" style="color:black">My Testimonials</span></a>

                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-primary elevation-1"><i class="fas fa-house-user"></i></span>

                        <div class="info-box-content">
                            <a :href=this.listing_route><span class="info-box-text" style="color:black">My Listings</span></a>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <div class="clearfix hidden-md-up"></div>

                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-user-edit"></i></span>

                        <div class="info-box-content">
                            <span class="info-box-text" @click.stop="edit()">Edit My Details</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>

                <!-- /.col -->
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-success elevation-1"><i class="fas fa-user"></i></span>

                        <div class="info-box-content">
                            <a :href=this.public_profile_route><span class="info-box-text" style="color:black">View My Public Profile</span></a>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
            </div>
            <!-- /.row -->

            <agent-links></agent-links>

            <!-- /.row -->
            <!-- Modals -->
            <b-modal id="editModal" ref="editModal" title="Edit Agent" size="lg">
                <agent-edit ref="editAgent" :agent="this.agent" :editing="true"></agent-edit>
                <div slot="modal-footer" class="w-100"></div>
            </b-modal>
        </div><!--/. container-fluid -->
    </section>
</template>

<script>
    export default {
        created(){
            let _self = this;
            axios.get('/api/me')
                .then(response => {
                    _self.agent = response.data.agent;
                });
        },
        data() {
            return {
                agent: null,
                testimonial_route: "/" + this.$slug + "/testimonials",
                listing_route: "agents/listings/" + this.$slug,
                public_profile_route: "/" + this.$slug
            }
        },
        methods: {
            edit() {
                this.$refs['editModal'].show();
            },
        },
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
